import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const IsNotLoggedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const authService = inject(AuthService);

  if (authService.isLogged) {
    router.navigate(['/home']);
    return false;
  }
  return true;
};
